export default __webpack_public_path__ + "static/media/areas.2e83bd4b.svg";